import ValidationErrors from '../fields/validationErrors';
import { ValidatorRule, ValidatorResult } from './validatorRule.constants';
import { BaseValidator } from './baseValidator';

export class CountryFieldValidator extends BaseValidator {
    public CountryLengthRule(value: string): ValidatorResult {
        const MAX_LENGTH = 255;
        if (value.length > MAX_LENGTH) {
            return {
                value: value,
                message: ValidationErrors.fieldTooLongMessageProps(MAX_LENGTH),
                rule: 'CountryLengthRule',
            };
        }

        return null;
    }

    constructor(rules = [ValidatorRule.CountryLengthRule]) {
        super(rules);
    }
}
